import quercusApi from '../../apis/quercusApi';
import { handleError } from '../../helpers/handleError';
import { getSearchString, getOrder } from '../../utils/filterUtils';
import {
    SC_FETCH_QCS,
    SC_FETCH_QCS_REQUEST,
    SC_FETCH_QCS_ERROR
} from './types';

export const fecthQcs = ({ offset, limit, queries }) => async (dispatch) => {
    dispatch({ type: SC_FETCH_QCS_REQUEST });
    try {
        let query = {
            params: {
                limit: limit,
                offset: offset 
            }
        };
        if (queries.length > 0){
          query.params.searchString = getSearchString(queries);
          query.params.order = getOrder(queries);
        }

        const response = await quercusApi.get('/sc2/qcs', query);
        dispatch({ type: SC_FETCH_QCS, payload: response.data });
    } catch (error) {
        dispatch({ type: SC_FETCH_QCS_ERROR, payload: handleError(error) });
    }
};